import EmblaCarousel, {
    type EmblaPluginType,
    type EmblaOptionsType
} from 'embla-carousel';

// Настройки отображения и управления слайдером

export const initEmbla = (
    container: HTMLElement,
    options?: Partial<EmblaOptionsType>,
    plugins?: EmblaPluginType[],
    onSlideClick?: (e: MouseEvent) => void
): void => {
    const init = () => {
        const emblaNode: HTMLElement = container.querySelector('.embla');
        if (!emblaNode) return;

        const emblaApi = EmblaCarousel(emblaNode, options, plugins);

        // Управляющие кнопки
        const prevBtn = container.querySelector<HTMLButtonElement>(
            '.pro-carousel-button[data-direction="prev"]'
        );
        const nextBtn = container.querySelector<HTMLButtonElement>(
            '.pro-carousel-button[data-direction="next"]'
        );

        if (prevBtn)
            prevBtn.addEventListener('click', () => emblaApi.scrollPrev());
        if (nextBtn)
            nextBtn.addEventListener('click', () => emblaApi.scrollNext());

        // Тени по краям
        const shadowContainer =
            emblaNode.querySelector<HTMLElement>('.shadow-container');

        const updateUI = () => {
            const canPrev = emblaApi.canScrollPrev();
            const canNext = emblaApi.canScrollNext();

            // Тени
            if (shadowContainer) {
                shadowContainer.classList.toggle(
                    'pro-carousel__slides--shadow-left',
                    canPrev
                );
                shadowContainer.classList.toggle(
                    'pro-carousel__slides--shadow-right',
                    canNext
                );
            }

            // Кнопки
            if (prevBtn) {
                prevBtn.style.display = canPrev ? 'flex' : 'none';
            }
            if (nextBtn) {
                nextBtn.style.display = canNext ? 'flex' : 'none';
            }
        };

        updateUI();
        emblaApi.on('select', updateUI);
        emblaApi.on('reInit', updateUI);

        // Обработчики кликов на слайдах
        if (onSlideClick) {
            emblaNode.querySelectorAll('.embla__slide').forEach(card => {
                card.addEventListener('click', e =>
                    onSlideClick(e as MouseEvent)
                );
                card.addEventListener('auxclick', e =>
                    onSlideClick(e as MouseEvent)
                );
            });
        }

        // Dots навигация
        const dotsContainer = emblaNode.querySelector('.embla__dots');
        if (dotsContainer) {
            const slidesCount =
                emblaNode.querySelectorAll('.embla__slide').length;
            if (slidesCount) {
                const existingDots = Array.from(
                    dotsContainer.querySelectorAll('button')
                );
                const dots = [...existingDots];

                existingDots.forEach((dot, i) =>
                    dot.addEventListener('click', () => emblaApi.scrollTo(i))
                );

                for (let i = existingDots.length; i < slidesCount; i++) {
                    const button = document.createElement('button');
                    if (i === 0 && existingDots.length === 0)
                        button.classList.add('is-selected');
                    button.type = 'button';
                    button.addEventListener('click', () =>
                        emblaApi.scrollTo(i)
                    );
                    dotsContainer.appendChild(button);
                    dots.push(button);
                }

                const selectDot = () => {
                    const selectedIndex = emblaApi.selectedScrollSnap();
                    dots.forEach((dot, index) =>
                        dot.classList.toggle(
                            'is-selected',
                            index === selectedIndex
                        )
                    );
                };

                emblaApi.on('select', selectDot);
                selectDot();
            }
        }
    };

    const isVisible = container.checkVisibility?.() ?? true;
    if (isVisible || typeof window === 'undefined') {
        init();
    } else if (window.requestIdleCallback) {
        window.requestIdleCallback(init, { timeout: 7000 });
    } else {
        setTimeout(init, 0);
    }
};
